{
  "title": "通知信與寄送紀錄",
  "description": "一覽主辦方操作會寄出的通知信（手動寄送與操作連帶通知）、信末聯絡信箱的來源，以及在稽核紀錄查看寄送結果。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "讓你知道哪些操作會寄信給誰，以及如何確認寄送成功。",
  "roleNote": "主辦方",
  "prerequisites": ["競賽設定已填寫「聯絡信箱」"],
  "pathLabel": "競賽管理 → 總覽 → 設定；競賽管理 → 稽核紀錄",
  "steps": [
    {
      "title": "1. 手動寄送的信",
      "description": "公告 Email、需補填的報名資料提醒、給隊長的報名提醒（隊伍管理頁）。這三種寄出前都會顯示人數確認與信件預覽，也就是「所見即所寄」。公告與補填提醒另有「寄測試信給我自己」。"
    },
    {
      "title": "2. 操作連帶通知",
      "description": "晉級決賽（通知入圍隊伍的隊員，不含教師）、作品退回修改（通知該隊隊員）、資格驗證未通過（通知該學生並附原因）、邀請或重新發送評審邀請（通知該評審，新帳號附一次性臨時登入資訊）。這些在你做該項操作時自動寄出，操作畫面會事先說明。"
    },
    {
      "title": "3. 信末的聯絡信箱",
      "description": "提醒與公告信的信末會附上競賽設定的「聯絡信箱」（在總覽頁的「設定」卡片維護，顯示為「主辦單位聯絡信箱」）；沒有填寫時信件不會出現這一行。「主辦單位聯絡方式」那段長篇文字只用於網站頁面，不會放進信件。"
    }
  ],
  "afterward": [
    "每一次寄送都會在稽核紀錄留下摘要，包含成功與失敗人數，不含 Email 位址",
    "寄信失敗不會使原本的操作失敗，畫面也不會即時提示失敗人數，需要到稽核紀錄查看",
    "已寄出的信無法收回"
  ],
  "nextSteps": "公告請見「如何發布公告並寄 Email 通知」，補填提醒請見「需補填的報名資料與提醒信」。",
  "faq": [
    {
      "q": "在哪裡看信有沒有寄成功？",
      "a": "在競賽管理的稽核紀錄，尋找通知信寄送結果的紀錄，會顯示成功與失敗人數。評審邀請失敗時，可在評審邀請清單使用「重新發送」。"
    },
    {
      "q": "信末的聯絡信箱要怎麼改？",
      "a": "到總覽頁的「設定」卡片修改「聯絡信箱」，之後寄出的信會使用新值；已寄出的信不會更新。"
    },
    {
      "q": "退回修改與解鎖都會寄信嗎？",
      "a": "退回修改會寄信給該隊隊員；解鎖不會寄信。"
    }
  ]
}
